import { Component, OnInit, Input } from "@angular/core";
import { StatusService } from "app/services/status.service";
import { AuthWebService } from "app/services/authweb.service";
import { CarrierService } from "app/services/carrier.service";
import { PermitService } from "app/services/permit.service";
import { ToastrService } from "ngx-toastr";
import { ApplicationService } from "app/services/application.service";
import { UtilityServiceService } from "app/services/utility-service.service";
import { Router } from "@angular/router";
import { environment } from "environments/environment";
import { ToastNotificationService } from "app/shared/toast-notification/toast-notification.service";

declare var $;

@Component({
  selector: "app-carriercorrespondence",
  templateUrl: "./carriercorrespondence.component.html",
  styleUrls: ["./carriercorrespondence.component.css"],
})
export class CarriercorrespondenceComponent implements OnInit {
  @Input("ctrlData") ctrlData: any;
  description: any;
  gridload: boolean = true;
  approvalRes: any;
  statuses: any = [];
  emailContacts: any = {};
  crspdType: any = "";
  crspdLead: any = "";
  crspdOwner: any = "";
  crspdContact: any = "";
  crStatus: any = null;
  changeStatus: any;
  statusId: any;
  aUser: any = {};

  constructor(
    private statusService: StatusService,
    private authWebService: AuthWebService,
    private carrierService: CarrierService,
    private permitService: PermitService,
    private toastr: ToastrService,
    private toastService: ToastNotificationService,
    private applicationService: ApplicationService,
    public utility: UtilityServiceService,
    private router: Router
  ) {
    this.aUser = environment.authWebApi.userData.User;
  }

  ngOnInit() {
    this.statusId = this.utility.approveStatusId;
    this.gridload = false;
    ////console.log(this.ctrlData.data);
    if (this.ctrlData == undefined || this.ctrlData == null) {
      this.ctrlData = this.utility.carrierObject;
    }
    this.approvalRes = this.ctrlData.data;
    this.changeStatus = this.approvalRes.Status;
    this.crStatus = parseInt(this.approvalRes.Status.split(",")[0]);
    this.approvalRes.statusId = this.crStatus;
    //console.log(this.utility.actionStatus);
    if (this.utility.btnAction == 1) {
      if (this.utility.actionStatus != 0) {
        // this.approvalRes.statusId=this.utility.actionStatus;
        // this.approvalRes.status_id=this.utility.actionStatus;
        this.approvalRes.Status = "Additional Information Required";
        this.approvalRes.statusId = this.approvalRes.status_id = 2;
      }
    } else if (
      this.crStatus != 21 &&
      this.crStatus != 31 &&
      this.utility.btnAction == 2
    ) {
      if (this.utility.actionStatus != 0) {
        // this.approvalRes.statusId=this.utility.actionStatus;
        // this.approvalRes.status_id=this.utility.actionStatus;
      }
    } else {
      this.approvalRes.statusId = this.crStatus;
    }

    this.getStatus(); // list of statuses
    this.retrieveSubmitStatus(); // eMail template
    this.getCorrespondenceTo(); // contacts
  }

  changes() {}

  statusUpdate() {
    console.log(this.approvalRes.statusId);
    this.approvalRes.status_id = this.approvalRes.statusId;
    let status = { description: "" };
    let desc: any = $("#statusCarrier option:selected").text().trim();
    let sts: any = this.approvalRes.statusId + ",  " + desc;
    //this.changeStatus=sts;
    this.approvalRes.Status = desc;
    //console.log(this.approvalRes);
    this.crStatus = this.approvalRes.statusId;

    if (this.approvalRes.statusId == 93) {
      this.description = this.authWebService.userData.Configurations.find(
        (config) => config.Code == "CarrierStatus93"
      ).Value.replace("helpdesk@cbrta.co.za", this.aUser.EmailAddress);
    } else {
      this.description = "";
    }
  }

  // list of statuses
  getStatus() {
    this.statusService.statusesDDL().subscribe((result) => {
      this.statuses = result;
    });
  }

  onSaveAndSend = () => {
    //console.log(this.description);
    //console.log(this.approvalRes);
    if (this.crspdType == "" || this.crspdType == null) {
      this.toastService.error("Email recipient is required.", "Email");
      return;
    }
    if (this.description == "" || this.description == null) {
      this.toastService.error("Email message is required.", "Email");
      return;
    }
    let body = {
      email: this.crspdType,
      body: this.description,
    };
    this.carrierService.putStatus(this.approvalRes).subscribe((res) => {
      this.sendEmail(body);
      this.ctrlData.data;
      this.changeView(1);
      if (this.utility.btnAction == 1) {
        this.toastService.success(
          "Request-for-additional-information email sent.",
          "Email"
        );
      } else if (this.utility.btnAction == 5) {
        this.toastService.success(
          "Status updated successfully and email sent.",
          "Email"
        );
      }
    });
  };

  redirectList() {
    this.changeView(1);
  }

  changeView = (activeC: number, action = 0) => {
    this.utility.currentActive = this.ctrlData.currentActive = activeC;
    this.ctrlData.action = action;
    this.utility.isBtnVisible = true;
    this.router.navigate(["account/approval"]);
  };

  sendEmail(body) {
    this.carrierService.sendApprovalEmail(body).subscribe((result) => {});
  }

  // eMail contacts
  getCorrespondenceTo() {
    this.carrierService
      .correspondenceToByCarrierId(this.ctrlData.data.Id)
      .subscribe((x) => {
        this.emailContacts = x;
        this.crspdLead = this.emailContacts.LeadUser;
        this.crspdContact = this.emailContacts.MainContact;
        if (this.emailContacts.Owner != "") {
          this.crspdOwner = this.emailContacts.Owner;
        } else if (this.approvalRes.Email != "") {
          this.crspdOwner = this.approvalRes.Email;
        }
        // this.crspdType=this.emailContacts.LeadUser;
        this.crspdType = this.crspdLead;
      });
  }

  // eMail template
  retrieveSubmitStatus = () => {
    if (this.authWebService.userData) {
      switch (this.utility.btnAction) {
        case 1:
          this.description = this.authWebService.userData.Configurations.find(
            (config) => config.Code == "AdditionalEmail1"
          ).Value.replace("helpdesk@cbrta.co.za", this.aUser.EmailAddress);
          break;
        case 2:
          this.description = this.authWebService.userData.Configurations.find(
            (config) => config.Code == "ConfirmEmail2"
          ).Value;
          break;
        default:
          break;
      }
    }
  };

  selectUser(email) {
    var recipients = "";

    var lead = "";
    var elementLead = <HTMLInputElement>document.getElementById("carrierLead");
    if (elementLead.checked) {
      lead = this.crspdLead;
      lead += "; ";
      recipients += lead;
    }

    var main = "";
    var elementMain = <HTMLInputElement>document.getElementById("carrierMain");
    if (elementMain.checked) {
      main = this.crspdContact;
      main += "; ";
      recipients += main;
    }

    var owner = "";
    var elementOwner = <HTMLInputElement>(
      document.getElementById("carrierOwner")
    );
    if (elementOwner.checked) {
      owner = this.crspdOwner;
      owner += "; ";
      recipients += owner;
    }

    // this.crspdType=email;
    recipients = recipients.trim();
    recipients = recipients.replace(/;+$/, "");
    this.crspdType = recipients;
  }
}
